export default __webpack_public_path__ + "static/media/search.10aba7d9.svg";